var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.subFormAvailable
    ? _c("div", [
        _c(
          "div",
          [
            _c(
              "b-row",
              { staticClass: "d-flex align-items-center" },
              [
                _c("h2", [_vm._v("\n                Forderung\n            ")]),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "klippa-subform-toggle-btn",
                    attrs: { variant: "primary" },
                    on: { click: _vm.toggleAll },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.someIncluded ? "Alle abwählen" : "Alle auswählen"
                        ) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-row",
                      [
                        _c("csp-desktop-info-card-element", {
                          staticClass: "col-12",
                          attrs: {
                            "default-value": _vm.NEW_COST_UNIT_SENTINEL,
                            "form-context": _vm.formContext,
                            label: "Auswahl Forderung",
                            options: _vm.initialCostUnitOptions,
                            "options-loader": _vm.loadCostUnitOptions,
                            property: "costUnitId",
                            "subform-identifier": _vm.subformIdentifier,
                            type: "autocomplete",
                          },
                          on: { change: _vm.onCostUnitSelected },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("csp-klippa-info-card-element", {
                          ref: "fieldReceipt",
                          staticClass: "col-12",
                          attrs: {
                            "form-context": _vm.formContext,
                            label: "Beleg Nr.",
                            property: "receipt",
                            "subform-identifier": _vm.subformIdentifier,
                            type: "text",
                          },
                          on: {
                            "field-hover-changed": (data) => {
                              _vm.$emit("field-hover-changed", data)
                            },
                            "field-inclusion-changed":
                              _vm.onFieldInclusionChangedWithTracking,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("csp-klippa-info-card-element", {
                          ref: "fieldAmount",
                          staticClass: "col-12",
                          attrs: {
                            "form-context": _vm.formContext,
                            label: "Bruttobetrag",
                            property: "amount",
                            "subform-identifier": _vm.subformIdentifier,
                            type: "currency",
                          },
                          on: {
                            "field-hover-changed": (data) => {
                              _vm.$emit("field-hover-changed", data)
                            },
                            "field-inclusion-changed":
                              _vm.onFieldInclusionChangedWithTracking,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("csp-klippa-info-card-element", {
                          ref: "fieldAmountNet",
                          staticClass: "col-12",
                          attrs: {
                            "form-context": _vm.formContext,
                            label: "Nettobetrag",
                            property: "amountNet",
                            "subform-identifier": _vm.subformIdentifier,
                            type: "currency",
                          },
                          on: {
                            "field-hover-changed": (data) => {
                              _vm.$emit("field-hover-changed", data)
                            },
                            "field-inclusion-changed":
                              _vm.onFieldInclusionChangedWithTracking,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("csp-klippa-info-card-element", {
                          ref: "fieldAmountVat",
                          staticClass: "col-12",
                          attrs: {
                            "form-context": _vm.formContext,
                            label: "USt.-Betrag",
                            property: "amountVat",
                            "subform-identifier": _vm.subformIdentifier,
                            type: "currency",
                          },
                          on: {
                            "field-hover-changed": (data) => {
                              _vm.$emit("field-hover-changed", data)
                            },
                            "field-inclusion-changed":
                              _vm.onFieldInclusionChangedWithTracking,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.copaymentAvailable
                      ? _c(
                          "b-row",
                          [
                            _c("csp-klippa-info-card-element", {
                              ref: "fieldAmountCopayment",
                              staticClass: "col-12",
                              attrs: {
                                "form-context": _vm.formContext,
                                label: "Selbstbeteiligung",
                                property: "amountCopayment",
                                "subform-identifier": _vm.subformIdentifier,
                                type: "currency",
                              },
                              on: {
                                "field-hover-changed": (data) => {
                                  _vm.$emit("field-hover-changed", data)
                                },
                                "field-inclusion-changed":
                                  _vm.onFieldInclusionChangedWithTracking,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("csp-klippa-info-card-element", {
                          ref: "fieldVatRate",
                          staticClass: "col-12",
                          attrs: {
                            "form-context": _vm.formContext,
                            label: "USt. (%)",
                            "options-loader": _vm.loadVatRateOptions,
                            property: "vatRate",
                            "subform-identifier": _vm.subformIdentifier,
                            type: "autocomplete",
                          },
                          on: {
                            "field-hover-changed": (data) => {
                              _vm.$emit("field-hover-changed", data)
                            },
                            "field-inclusion-changed":
                              _vm.onFieldInclusionChangedWithTracking,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("csp-klippa-info-card-element", {
                          ref: "fieldPaymentComment",
                          staticClass: "col-12",
                          attrs: {
                            "form-context": _vm.formContext,
                            label: "Bemerkung",
                            property: "paymentComment",
                            "subform-identifier": _vm.subformIdentifier,
                            type: "textarea",
                          },
                          on: {
                            "field-hover-changed": (data) => {
                              _vm.$emit("field-hover-changed", data)
                            },
                            "field-inclusion-changed":
                              _vm.onFieldInclusionChangedWithTracking,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.isLoading
          ? _c(
              "div",
              {
                staticClass:
                  "loading-overlay d-flex justify-content-center pt-5",
              },
              [_c("csp-loading-indicator")],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }